import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Helper function to convert boolean to number
export const boolToNumber = (value: boolean | undefined): number => {
  return value ? 1 : 0;
};

export const formatSessionTime = (timestamp: number) => {
  const sessionDate = new Date(timestamp * 1000);
  const today = new Date();

  const isSameDay =
    sessionDate.getDate() === today.getDate() &&
    sessionDate.getMonth() === today.getMonth() &&
    sessionDate.getFullYear() === today.getFullYear();

  if (isSameDay) {
    return sessionDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } else {
    return (
      sessionDate.toLocaleDateString() + " "
      //  +
      // sessionDate.toLocaleTimeString([], {
      //   hour: "2-digit",
      //   minute: "2-digit",
      // })
    );
  }
};

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours(); // local hours (no leading zero)
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formatted = `${month}/${day}/${year} ${hours}:${minutes}`;
  return formatted;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  const formatted = `${month}/${day}/${year}`;
  return formatted;
};
